
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAccordionCard as ObcAccordionCardElement} from '@oicl/openbridge-webcomponents/dist/components/accordion-card/accordion-card.js';
 
 
 

 
 export const ObcAccordionCard = createComponent({
   react: React,
   tagName: 'obc-accordion-card',
   elementClass: ObcAccordionCardElement,
   events: {
     
     onAccordionToggle: 'accordion-toggle' as EventName<CustomEvent<{expanded: boolean, cardTitle: string}>>,
   }
  });
 
 